"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIMaintenanceMonthlyPlanSchedule = exports.IMaintenanceMonthlyPlanScheduleKindEnum = void 0;
const imaintenance_monthly_slot_1 = require("./imaintenance-monthly-slot");
/**
    * @export
    * @enum {string}
    */
var IMaintenanceMonthlyPlanScheduleKindEnum;
(function (IMaintenanceMonthlyPlanScheduleKindEnum) {
    IMaintenanceMonthlyPlanScheduleKindEnum["MonthlyPlan"] = "monthly_plan";
})(IMaintenanceMonthlyPlanScheduleKindEnum || (exports.IMaintenanceMonthlyPlanScheduleKindEnum = IMaintenanceMonthlyPlanScheduleKindEnum = {}));
function parseIMaintenanceMonthlyPlanSchedule(data) {
    if (data.slots !== null && typeof data.slots === 'object')
        data.slots = data.slots.map((x) => (0, imaintenance_monthly_slot_1.parseIMaintenanceMonthlySlot)(x));
    return data;
}
exports.parseIMaintenanceMonthlyPlanSchedule = parseIMaintenanceMonthlyPlanSchedule;
